import React from 'react';
import { Mountain, MapPin, Shield } from 'lucide-react';
import { motion } from 'framer-motion';
export function WhyCarefree() {
  const reasons = [{
    icon: <Mountain className="w-8 h-8 text-sand" data-id="element-128" />,
    title: 'Luxury Desert Lifestyle & Natural Beauty',
    description: 'North Scottsdale sits at 2,400 ft elevation in the Sonoran Desert, offering panoramic mountain views, iconic boulder formations, and a slower pace that draws buyers seeking beauty and space over density.'
  }, {
    icon: <MapPin className="w-8 h-8 text-sand" data-id="element-129" />,
    title: 'World-Class Golf & Resort Amenities',
    description: "The area is home to championship desert golf courses, a world-renowned resort spa, and the kind of amenity-rich lifestyle typically reserved for the world's top destinations — all just outside your door."
  }, {
    icon: <Shield className="w-8 h-8 text-sand" data-id="element-130" />,
    title: 'Peace, Privacy & Escape from Urban Life',
    description: 'With a population of just 4,000, virtually no traffic, and a crime rate 76% below the national average, North Scottsdale offers a genuine retreat from the hustle of city living — without sacrificing access to Scottsdale just 25 miles away.'
  }];
  return <section id="why-carefree" className="py-24 md:py-32 bg-cream" data-id="element-131">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-132">
        <div className="text-center mb-16 md:mb-24" data-id="element-133">
          <h2 className="text-4xl md:text-5xl font-serif text-stone-deep mb-4" data-id="element-134">
            Why Buyers Choose North Scottsdale
          </h2>
          <div className="w-24 h-px bg-sand mx-auto" data-id="element-135"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-136">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-cream border border-sand/30 rounded-2xl p-8 md:p-10 hover:border-brown/40 transition-colors duration-300 flex flex-col items-center text-center" data-id="element-137">
              <div className="w-16 h-16 rounded-full bg-stone-deep flex items-center justify-center mb-8" data-id="element-138">
                {reason.icon}
              </div>
              <h3 className="text-xl font-serif text-stone-deep font-semibold mb-4 leading-snug" data-id="element-139">
                {reason.title}
              </h3>
              <p className="text-stone-deep/80 leading-relaxed" data-id="element-140">
                {reason.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}